import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=10890c55&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10890c55')) {
      api.createRecord('10890c55', component.options)
    } else {
      api.reload('10890c55', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=10890c55&", function () {
      api.rerender('10890c55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/Filters.vue"
export default component.exports